import { lazy } from 'react';

import MainLayout from 'layout/MainLayout';
import Loadable from 'components/Loadable';
import CommonLayout from 'layout/CommonLayout';
import AuthGuard from 'utils/route-guard/AuthGuard';

import Widget from '../components/profile/Widget';

const DashboardDefault = Loadable(lazy(() => import('pages/dashboard')));
const EcomDashboard = Loadable(lazy(() => import('pages/ecom_dashboard/ecom_dashboard')));
const MapOfLocation = Loadable(lazy(() => import('pages/map')));
const Devices = Loadable(lazy(() => import('pages/devices')));
const Companies = Loadable(lazy(() => import('pages/companies')));
const Users = Loadable(lazy(() => import('pages/widget/data')));
const EcomCompany = Loadable(lazy(() => import('pages/ecom_company/EcomCompanyContainer')));
const UsersIntegration = Loadable(lazy(() => import('pages/ecom_users_integration/ecom_users_integration')));

const Orders = Loadable(lazy(() => import('pages/orders')));
const EcomOrders = Loadable(lazy(() => import('pages/ecom_orders/order_list/ecom_orders')));
const CreateOrders = Loadable(lazy(() => import('pages/ecom_orders/create_orders/CreateOrder')));
const UpdateOrder = Loadable(lazy(() => import('pages/ecom_orders/update_order/update_order')));
const DetailOrders = Loadable(lazy(() => import('pages/ecom_orders/detail_orders/detail_orders')));
const TariffCalculator = Loadable(lazy(() => import('pages/tariff_calculator/TariffCalculator')));
const EcomOwnPoints = Loadable(lazy(() => import('pages/ecom_points/own_points/ecom_points')));
const EcomLogisticianPoints = Loadable(lazy(() => import('pages/ecom_points/logistiacian_points/logistiacian_points')));
const EcomLogisticianPointsDetail = Loadable(lazy(() => import('pages/ecom_points/logistiacian_points/detail_point/detail_point')));
const Storage = Loadable(lazy(() => import('pages/storages')));
const Requests = Loadable(lazy(() => import('pages/requests/requests')));
const KnowledgeBase = Loadable(lazy(() => import('pages/knowledgeBase')));
const Settings = Loadable(lazy(() => import('pages/settings')));
const News = Loadable(lazy(() => import('pages/news/news')));
const CouriersCall = Loadable(lazy(() => import('pages/courier_call/couriers_list/courier_call')));
const CreateCouriersCall = Loadable(lazy(() => import('pages/courier_call/create_couriers/CreateCouriers')));
const CreateCouriersCallInfo = Loadable(lazy(() => import('pages/courier_call/couriersInfo')));
const Tariff = Loadable(lazy(() => import('pages/tariff/tariff')));
const Billing = Loadable(lazy(() => import('pages/billing/billing')));
const Reports = Loadable(lazy(() => import('pages/reports/reports')));
const ImportOrders = Loadable(lazy(() => import('pages/ecom_orders/import_orders/import_orders')));
const Tracking = Loadable(lazy(() => import('pages/ecom_orders/tracking/tracking')));
const Profile = Loadable(lazy(() => import('components/profile')));
const Welcome = Loadable(lazy(() => import('components/welcome/Welcome')));

const WidgetStatistics = Loadable(lazy(() => import('pages/statistics')));
const WidgetData = Loadable(lazy(() => import('pages/widget/data')));
const WidgetChart = Loadable(lazy(() => import('pages/widget/chart')));

const AppChat = Loadable(lazy(() => import('pages/apps/chat')));
const AppCalendar = Loadable(lazy(() => import('pages/apps/calendar')));
const AppCustomerList = Loadable(lazy(() => import('pages/apps/customer/list')));

const UserProfile = Loadable(lazy(() => import('pages/apps/profiles/user')));
const UserTabPersonal = Loadable(lazy(() => import('sections/apps/profiles/user/TabPersonal')));
const UserTabPayment = Loadable(lazy(() => import('sections/apps/profiles/user/TabPayment')));
const UserTabCompany = Loadable(lazy(() => import('pages/ecom_company/EcomCompanyContainer')));
const UserTabPassword = Loadable(lazy(() => import('components/profile')));
const UserTabSettings = Loadable(lazy(() => import('sections/apps/profiles/user/TabSettings')));

const AccountProfile = Loadable(lazy(() => import('pages/apps/profiles/account')));
const AccountTabProfile = Loadable(lazy(() => import('sections/apps/profiles/account/TabProfile')));
const AccountTabPersonal = Loadable(lazy(() => import('sections/apps/profiles/account/TabPersonal')));
const AccountTabAccount = Loadable(lazy(() => import('sections/apps/profiles/account/TabAccount')));
const AccountTabPassword = Loadable(lazy(() => import('sections/apps/profiles/account/TabPassword')));
const AccountTabRole = Loadable(lazy(() => import('sections/apps/profiles/account/TabRole')));
const AccountTabSettings = Loadable(lazy(() => import('sections/apps/profiles/account/TabSettings')));

const ProfileUserList = Loadable(lazy(() => import('pages/apps/profiles/user-list')));
const ProfileUserCard = Loadable(lazy(() => import('pages/apps/profiles/user-card')));

const AppECommProducts = Loadable(lazy(() => import('pages/apps/e-commerce/product')));
const AppECommProductDetails = Loadable(lazy(() => import('pages/apps/e-commerce/product-details')));
const AppECommProductList = Loadable(lazy(() => import('pages/apps/e-commerce/products-list')));
const AppECommCheckout = Loadable(lazy(() => import('pages/apps/e-commerce/checkout')));
const AppECommAddProduct = Loadable(lazy(() => import('pages/apps/e-commerce/add-product')));

const FormsValidation = Loadable(lazy(() => import('pages/forms/validation')));
const FormsWizard = Loadable(lazy(() => import('pages/forms/wizard')));

const FormsLayoutBasic = Loadable(lazy(() => import('pages/forms/layouts/basic')));
const FormsLayoutMultiColumn = Loadable(lazy(() => import('pages/forms/layouts/multi-column')));
const FormsLayoutActionBar = Loadable(lazy(() => import('pages/forms/layouts/action-bar')));
const FormsLayoutStickyBar = Loadable(lazy(() => import('pages/forms/layouts/sticky-bar')));

const FormsPluginsMask = Loadable(lazy(() => import('pages/forms/plugins/mask')));
const FormsPluginsClipboard = Loadable(lazy(() => import('pages/forms/plugins/clipboard')));
const FormsPluginsRecaptcha = Loadable(lazy(() => import('pages/forms/plugins/re-captcha')));
const FormsPluginsEditor = Loadable(lazy(() => import('pages/forms/plugins/editor')));
const FormsPluginsDropzone = Loadable(lazy(() => import('pages/forms/plugins/dropzone')));

const ReactTableBasic = Loadable(lazy(() => import('pages/tables/react-table/basic')));
const ReactTableSorting = Loadable(lazy(() => import('pages/tables/react-table/sorting')));
const ReactTableFiltering = Loadable(lazy(() => import('pages/tables/react-table/filtering')));
const ReactTableGrouping = Loadable(lazy(() => import('pages/tables/react-table/grouping')));
const ReactTablePagination = Loadable(lazy(() => import('pages/tables/react-table/pagination')));
const ReactTableRowSelection = Loadable(lazy(() => import('pages/tables/react-table/row-selection')));
const ReactTableExpanding = Loadable(lazy(() => import('pages/tables/react-table/expanding')));
const ReactTableEditable = Loadable(lazy(() => import('pages/tables/react-table/editable')));
const ReactTableDragDrop = Loadable(lazy(() => import('pages/tables/react-table/drag-drop')));
const ReactTableColumnHiding = Loadable(lazy(() => import('pages/tables/react-table/column-hiding')));
const ReactTableUmbrella = Loadable(lazy(() => import('pages/tables/react-table/umbrella')));

// render - charts & map
const ChartApexchart = Loadable(lazy(() => import('pages/charts/apexchart')));
const ChartOrganization = Loadable(lazy(() => import('pages/charts/org-chart')));

// table routing
const MuiTableBasic = Loadable(lazy(() => import('pages/tables/mui-table/basic')));
const MuiTableDense = Loadable(lazy(() => import('pages/tables/mui-table/dense')));
const MuiTableEnhanced = Loadable(lazy(() => import('pages/tables/mui-table/enhanced')));
const MuiTableDatatable = Loadable(lazy(() => import('pages/tables/mui-table/datatable')));
const MuiTableCustom = Loadable(lazy(() => import('pages/tables/mui-table/custom')));
const MuiTableFixedHeader = Loadable(lazy(() => import('pages/tables/mui-table/fixed-header')));
const MuiTableCollapse = Loadable(lazy(() => import('pages/tables/mui-table/collapse')));

// pages routing
const Login = Loadable(lazy(() => import('pages/auth/login')));
const AuthRegister = Loadable(lazy(() => import('pages/auth/register')));
const AuthForgotPassword = Loadable(lazy(() => import('pages/auth/forgot-password')));
const AuthResetPassword = Loadable(lazy(() => import('pages/auth/reset-password')));
const AuthCheckMail = Loadable(lazy(() => import('pages/auth/check-mail')));
const AuthCodeVerification = Loadable(lazy(() => import('pages/auth/code-verification')));

const MaintenanceError = Loadable(lazy(() => import('pages/maintenance/404')));
const MaintenanceError500 = Loadable(lazy(() => import('pages/maintenance/500')));
const MaintenanceUnderConstruction = Loadable(lazy(() => import('pages/maintenance/under-construction')));
const MaintenanceComingSoon = Loadable(lazy(() => import('pages/maintenance/coming-soon')));

const AppContactUS = Loadable(lazy(() => import('pages/contact-us')));

// render - sample page
const SamplePage = Loadable(lazy(() => import('pages/extra-pages/sample-page')));
const PricingPage = Loadable(lazy(() => import('pages/extra-pages/pricing')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      element: (
        <AuthGuard>
          <MainLayout />
        </AuthGuard>
      ),
      children: [
        {
          path: 'welcome',
          element: <Welcome />
        },
        {
          path: 'dashboard',
          element: <EcomDashboard />
        },
        {
          path: 'ecom_dashboard',
          element: <DashboardDefault />
        },
        {
          path: 'map',
          element: <MapOfLocation />
        },
        {
          path: 'statistics',
          element: <WidgetStatistics />
        },
        {
          path: 'devices',
          element: <Devices />
        },
        {
          path: 'companies',
          element: <Companies />
        },
        {
          path: 'profiles',
          element: <Users />
        },
        {
          path: 'ecom_company',
          element: <EcomCompany />
        },

        {
          path: 'ecom_users_integration',
          element: <UsersIntegration />
        },
        {
          path: 'orders',
          element: <Orders />
        },
        {
          path: 'logistician_points',
          element: <EcomLogisticianPoints />
        },
        {
          path: 'logistician_points/:uid/view',
          element: <EcomLogisticianPointsDetail />
        },
        {
          path: 'ecom_orders',
          element: <EcomOrders />
        },
        {
          path: 'ecom_orders/update/:id',
          element: <UpdateOrder />
        },
        {
          path: 'ecom_orders/create_orders',
          element: <CreateOrders />
        },
        {
          path: 'ecom_orders/import_order',
          element: <ImportOrders />
        },
        {
          path: 'ecom_orders/tracking',
          element: <Tracking />
        },
        {
          path: `/ecom_orders/:uid/view/`,
          element: <DetailOrders />
        },
        {
          path: `/tariff_calculator`,
          element: <TariffCalculator />
        },
        {
          path: 'news',
          element: <News />
        },
        {
          path: 'couriers',
          element: <CouriersCall />
        },
        {
          path: 'couriers/create_couriers_call',
          element: <CreateCouriersCall />
        },
        {
          path: 'couriers/:id/view/',
          element: <CreateCouriersCallInfo />
        },
        {
          path: 'tariff',
          element: <Tariff />
        },
        {
          path: 'billing',
          element: <Billing />
        },
        {
          path: 'reports',
          element: <Reports />
        },
        {
          path: 'storages',
          element: <Storage />
        },
        {
          path: 'requests',
          element: <Requests />
        },
        {
          path: 'knowledgebase',
          element: <KnowledgeBase />
        },
        {
          path: 'settings',
          element: <Settings />
        },
        {
          path: 'profile',
          element: <Profile />
        },
        {
          path: 'data',
          element: <WidgetData />
        },
        {
          path: 'chart',
          element: <WidgetChart />
        },
        {
          path: 'chat',
          element: <AppChat />
        },
        {
          path: 'apps',
          children: [
            {
              path: 'calendar',
              element: <AppCalendar />
            },
            {
              path: 'customer',
              children: [
                {
                  path: 'list',
                  element: <AppCustomerList />
                }
              ]
            },
            {
              path: 'profiles',
              children: [
                {
                  path: 'account',
                  element: <AccountProfile />,
                  children: [
                    {
                      path: 'basic',
                      element: <AccountTabProfile />
                    },
                    {
                      path: 'ecom_company',
                      element: <UserTabCompany />
                    },
                    {
                      path: 'own_points',
                      element: <EcomOwnPoints />
                    },
                    {
                      path: 'ecom_users_integration',
                      element: <UsersIntegration />
                    },
                    {
                      path: 'personal',
                      element: <AccountTabPersonal />
                    },
                    {
                      path: 'my-account',
                      element: <AccountTabAccount />
                    },
                    {
                      path: 'password',
                      element: <UserTabPassword />
                    },
                    {
                      path: 'role',
                      element: <AccountTabRole />
                    },
                    {
                      path: 'widget',
                      element: <Widget />
                    },
                    {
                      path: 'settings',
                      element: <AccountTabSettings />
                    }
                  ]
                },
                {
                  path: 'user',
                  element: <UserProfile />,
                  children: [
                    {
                      path: 'personal',
                      element: <UserTabPersonal />
                    },
                    {
                      path: 'payment',
                      element: <UserTabPayment />
                    },
                    {
                      path: 'password',
                      element: <AccountTabPassword />
                    },
                    {
                      path: 'settings',
                      element: <UserTabSettings />
                    }
                  ]
                },
                {
                  path: 'user-list',
                  element: <ProfileUserList />
                },
                {
                  path: 'user-card',
                  element: <ProfileUserCard />
                }
              ]
            },
            {
              path: 'e-commerce',
              children: [
                {
                  path: 'products',
                  element: <AppECommProducts />
                },
                {
                  path: 'product-details/:id',
                  element: <AppECommProductDetails />
                },
                {
                  path: 'product-list',
                  element: <AppECommProductList />
                },
                {
                  path: 'add-new-product',
                  element: <AppECommAddProduct />
                },
                {
                  path: 'checkout',
                  element: <AppECommCheckout />
                }
              ]
            }
          ]
        },
        {
          path: 'forms',
          children: [
            {
              path: 'validation',
              element: <FormsValidation />
            },
            {
              path: 'wizard',
              element: <FormsWizard />
            },
            {
              path: 'layout',
              children: [
                {
                  path: 'basic',
                  element: <FormsLayoutBasic />
                },
                {
                  path: 'multi-column',
                  element: <FormsLayoutMultiColumn />
                },
                {
                  path: 'action-bar',
                  element: <FormsLayoutActionBar />
                },
                {
                  path: 'sticky-bar',
                  element: <FormsLayoutStickyBar />
                }
              ]
            },
            {
              path: 'plugins',
              children: [
                {
                  path: 'mask',
                  element: <FormsPluginsMask />
                },
                {
                  path: 'clipboard',
                  element: <FormsPluginsClipboard />
                },
                {
                  path: 're-captcha',
                  element: <FormsPluginsRecaptcha />
                },
                {
                  path: 'editor',
                  element: <FormsPluginsEditor />
                },
                {
                  path: 'dropzone',
                  element: <FormsPluginsDropzone />
                }
              ]
            }
          ]
        },
        {
          path: 'tables',
          children: [
            {
              path: 'react-table',
              children: [
                {
                  path: 'basic',
                  element: <ReactTableBasic />
                },
                {
                  path: 'sorting',
                  element: <ReactTableSorting />
                },
                {
                  path: 'filtering',
                  element: <ReactTableFiltering />
                },
                {
                  path: 'grouping',
                  element: <ReactTableGrouping />
                },
                {
                  path: 'pagination',
                  element: <ReactTablePagination />
                },
                {
                  path: 'row-selection',
                  element: <ReactTableRowSelection />
                },
                {
                  path: 'expanding',
                  element: <ReactTableExpanding />
                },
                {
                  path: 'editable',
                  element: <ReactTableEditable />
                },
                {
                  path: 'drag-drop',
                  element: <ReactTableDragDrop />
                },
                {
                  path: 'column-hiding',
                  element: <ReactTableColumnHiding />
                },
                {
                  path: 'umbrella',
                  element: <ReactTableUmbrella />
                }
              ]
            },
            {
              path: 'mui-table',
              children: [
                {
                  path: 'basic',
                  element: <MuiTableBasic />
                },
                {
                  path: 'dense',
                  element: <MuiTableDense />
                },
                {
                  path: 'enhanced',
                  element: <MuiTableEnhanced />
                },
                {
                  path: 'datatable',
                  element: <MuiTableDatatable />
                },
                {
                  path: 'custom',
                  element: <MuiTableCustom />
                },
                {
                  path: 'fixed-header',
                  element: <MuiTableFixedHeader />
                },
                {
                  path: 'collapse',
                  element: <MuiTableCollapse />
                }
              ]
            }
          ]
        },
        {
          path: 'charts',
          children: [
            {
              path: 'apexchart',
              element: <ChartApexchart />
            },
            {
              path: 'org-chart',
              element: <ChartOrganization />
            }
          ]
        },
        {
          path: 'sample-page',
          element: <SamplePage />
        },
        {
          path: 'pricing',
          element: <PricingPage />
        }
      ]
    },
    {
      path: '/maintenance',
      element: <CommonLayout />,
      children: [
        {
          path: '404',
          element: <MaintenanceError />
        },
        {
          path: '500',
          element: <MaintenanceError500 />
        },
        {
          path: 'under-construction',
          element: <MaintenanceUnderConstruction />
        },
        {
          path: 'coming-soon',
          element: <MaintenanceComingSoon />
        }
      ]
    },
    {
      path: '/auth',
      element: <CommonLayout />,
      children: [
        {
          path: 'login',
          element: <Login />
        },
        {
          path: 'register',
          element: <AuthRegister />
        },
        {
          path: 'forgot-password',
          element: <AuthForgotPassword />
        },
        {
          path: 'reset-password',
          element: <AuthResetPassword />
        },
        {
          path: 'check-mail',
          element: <AuthCheckMail />
        },
        {
          path: 'code-verification',
          element: <AuthCodeVerification />
        }
      ]
    },
    {
      path: '/',
      element: <CommonLayout layout="simple" />,
      children: [
        {
          path: 'contact-us',
          element: <AppContactUS />
        }
      ]
    }
  ]
};

export default MainRoutes;
